
<div class="pt-4">
    <div class="row">
        <div class="col-md-3 col-xs-3 col-lg-3">
            <div class="initiative-dropdown">
                <app-dropdown-with-search [Pixeltracking]="true" placeholder="Select initiative"
                    searchFlag="false" isMultiSelect="false" [dropdownData]="initiativeList"
                    (selectionChange)="getSelectedIni($event)" [selected]="[]"></app-dropdown-with-search>
            </div>
        </div>
    </div>

    <div class="lob-model-view" *ngIf="selectedInitiative?.initiative_ID">
        <div class=" uitk-l-grid__col--sm-12 uitk-l-grid__col--m-12 uitk-l-grid__col--lg-12 ps-0 pe-0">
            <div class="uitk-c-card uhc-font">
                
                <div class="uitk-c-card__content" style="margin-top: 0px !important;">
                    <div class="stk-table-container ei-role-table">
                        <mat-tab-group>
                            <mat-tab label="Role Management">
                                <app-enterprise-initiative-role-management [selectedInitiative]="selectedInitiative" [isUserAdmin]="isUserAdmin" [initiativeList]="initiativeList"></app-enterprise-initiative-role-management>
                            </mat-tab>
                            <mat-tab label="Field Management"> 
                                <app-enterprise-initiative-field-management *ngIf="fieldData" [selectedInitiative]="selectedInitiative" [initiativeId]="this.selectedInitiative.initiative_ID" [fieldData]="fieldData" (refreshData)="refreshData($event)"></app-enterprise-initiative-field-management>
                            </mat-tab>
                        </mat-tab-group>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    
</div>

